import React, { FC } from 'react';

import { SerializedStyles } from '@emotion/react';
import Box from '@mui/material/Box';
import { alpha, Theme } from '@mui/material/styles';

import styled, { css } from '../../../../styled';
import { colorsPalette } from '../../../../theme';
import { NavigationItem } from '../../../../types';
import { ExpandedNavigationItem } from '../../const';
import { MenuItem } from '../MenuItem';

interface MenuItemsProps {
  isMobile: boolean;
  hasSubscription: boolean;
  items?: (NavigationItem | ExpandedNavigationItem)[];
  scrolled?: boolean;
  wrapperCss?: SerializedStyles | (({ theme }: { theme: Theme }) => SerializedStyles);
  isManager?: boolean | null;
  handleClickLink?: () => void;
}

const MenuItems: FC<MenuItemsProps> = ({
  isManager,
  isMobile,
  hasSubscription,
  items,
  scrolled = false,
  wrapperCss,
  handleClickLink,
}) => {
  if (items?.length === 0) {
    return null;
  }

  return (
    <Wrapper optionalStyles={wrapperCss}>
      {items &&
        items.map((item, i) => (
          <MenuItem
            key={item?.url}
            item={item}
            isMobile={isMobile}
            isManager={isManager}
            hasSubscription={hasSubscription}
            wrapperCss={menuItemWrapperCss(i === items.length - 1)}
            handleClickLink={handleClickLink}
            scrolled={scrolled}
          />
        ))}
      <HeaderBackgroundBox className="headerBackgroundBox" />
    </Wrapper>
  );
};

export default MenuItems;

const Wrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'optionalStyles',
})`
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.breakpoints.up('xl')} {
    flex-direction: row;
  }
  ${({ optionalStyles }) => optionalStyles}
`;
const menuItemWrapperCss =
  (isLastItem) =>
  ({ theme }) =>
    css`
      border-bottom: ${isLastItem ? 'none' : '1px solid ' + alpha(colorsPalette.white, 0.15)};
      ${theme.breakpoints.up('xl')} {
        border-bottom: none;
        &.hasSubItems:hover ~ .headerBackgroundBox {
          opacity: 1;
          background: ${colorsPalette.blackSecondary};
        }
      }
    `;
const HeaderBackgroundBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'scrolled',
})`
  width: 100vw;
  position: absolute;
  background: transparent;
  height: ${({ scrolled }) => (scrolled ? '80' : '100')}px;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  display: none;
  ${({ theme }) => theme.breakpoints.up('xl')} {
    display: block;
  }
`;
